import { Typography } from '@mui/material';
import useParamsSetFilters from 'hooks/useParamsSetFilters';
import React, { ReactElement } from 'react';
import SectionTitle from './common/SectionTitle';
import ContentGenres from './onDemand/ContentGenres';
import List from './onDemand/List';
import SavedSection from './onDemand/SavedSection';

const Classes = (): ReactElement => {
  const { loading } = useParamsSetFilters();

  return (
    <div>
      {!loading ? (
        <>
          <SavedSection />
          <SectionTitle role="heading" aria-level={2}>
            On Demand
          </SectionTitle>
          <ContentGenres key="on-demand-list-cg" />
          <List key="on-demand-list" />
        </>
      ) : (
        <Typography>Loading...</Typography>
      )}
    </div>
  );
};

export default Classes;
